<template>
  <div :class="{ 'drawer-content': $vuetify.breakpoint.mdAndUp }">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.drawer-content {
  margin-left: 56px;
}
</style>
